import { Flex, Icon, InlineStack, SkeletonText, Text, Tooltip } from '@customerio/pluma-components/react';
import type { UsageSummary } from '../utils/usage-summary';

/**
 * Where one row is used, as much of it as a column can hold.
 *
 * The counts arrive from their own read, after the rows, so the cell is a
 * skeleton until they land rather than a dash that turns into numbers.
 */

type UsageCellProps = {
  summary: UsageSummary;
  isLoading: boolean;
};

export function UsageCell({ summary, isLoading }: UsageCellProps) {
  if (isLoading) {
    return <SkeletonText text="product-p" lines={['60px']} />;
  }

  if (summary.chips.length === 0) {
    return <Text color="subtle">-</Text>;
  }

  return (
    <Tooltip content={summary.tooltip} placement="top">
      <InlineStack gap="100">
        {summary.chips.map((chip) => (
          <Flex key={chip.icon} gap="050" alignItems="center">
            <Icon name={chip.icon} size="sm" />
            <Text size="sm">{chip.count}</Text>
          </Flex>
        ))}
      </InlineStack>
    </Tooltip>
  );
}
